<div id="layout-wrapper layout-wrapper-vertical">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar (titleSideBar)="getTitle($event)" [isCondensed]="isCondensed"></app-sidebar>

  <div class="main-content main-content-vertical">
    <div class="page-content page-content-vertical">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer #footerVertical></app-footer>
  </div>
</div>

<app-rightsidebar></app-rightsidebar>
